import React from 'react';

import {Link as ReactRouterLink} from 'react-router-dom';
import Divider from 'muicss/lib/react/divider';

import GridRow from 'muicss/lib/react/row';
import GridCol from 'muicss/lib/react/col';

import GridContainer from 'muicss/lib/react/container';

import Radium from 'radium';
import Loader from 'views/Loader';
import Slider from "react-slick";

import MUIButton from 'muicss/lib/react/button';

const MBtn = Radium(MUIButton);

//Note: Radium does not work with MUI button, so use mui-custom.css file to modify it
export const Button = Radium((props) => {
  let button = null;

  if(props.mui === 'true') {
      button = <MBtn style={props.style} {...props}>{props.children}</MBtn>;
  } else {
      button = <button style={props.style} {...props}>{props.children}</button>;
  }

  if(props.href || props.to) {
    let routerProps = Object.assign({}, props);
    if(typeof routerProps.onClick === 'function') {
      delete routerProps.onClick;
    }
    return <ReactRouterLink to={props.href} {...routerProps}>{button}</ReactRouterLink>;
  } else {
    return button;
  }
});

const Link = Radium(ReactRouterLink);
export const A = Radium((props) => {

  if(props.href.startsWith("http"))
    return <a target="_blank" rel="nofollow" href={props.href} {...props}>{props.children}</a>;

  if(props.disabled === true) {
      let linkStyle = props.style || {};
      const disabledStyle = {background: 'gray', color: 'white'};
      if(Array.isArray(linkStyle)) {
        linkStyle.push([disabledStyle]);
      } else {
        linkStyle = Object.assign(linkStyle, disabledStyle);
      }

      return <Link to="#" style={linkStyle} onClick={(e) => {
        e.preventDefault();
      }}>{props.children}</Link>;    
  }
  return <Link to={props.href} {...props}>{props.children}</Link>;
});




//-- Grid 
const G = Radium(GridContainer);
export const Container = (props) => {
  return <G {...props}>{props.children}</G>
};

const R = Radium(GridRow);
export const Row = (props) => {
  return <R {...props}>{props.children}</R>
};

const C = Radium(GridCol);
export const Col = (props) => {
  return <C {...props}>{props.children}</C>
};


class AppImg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {imageLoaded: false};
  }

  onImageLoad(img) {
    this.setState({imageLoaded: true});
    if(this.props.onImgLoad && typeof this.props.onImgLoad === 'function')
      this.props.onImgLoad(img);
  }

  render() {
    const height = this.props.height;
    const width = this.props.width;

    let dimensionStyle = {};

    if(height) dimensionStyle.height = height;
    if(width) dimensionStyle.width = width;      

    const styles = Object.assign({}, dimensionStyle, (this.props.style? this.props.style: {}));
    const title = this.props.alt || "Seto Canvas Img";



    if(this.state.imageLoaded === false) {
        return <div style={styles} className='imgLoader'>
          <Loader noEffect={true} style={styles} className={this.props.className} />

          {
            this.props.src && 
            <img src={this.props.src} id={this.props.id} className='invisible' style={{width: '100%'}} title={title} alt={title} onLoad={this.onImageLoad.bind(this)} />
          }
          
        </div>
    }

    
    return <img src={this.props.src} id={this.props.id} title={title} alt={title} style={styles} 
                className={this.props.className} 
                onLoad={this.onImageLoad.bind(this)} />
  }
};


export const Img = Radium((props) => {
  return <AppImg {...props} />
});



export const Title = Radium((props) => {
    if(!props.title)
      return null;
    
    const styles = [{color: '#3d3d3d', textAlign: 'center', margin: '20px 0', 
                  '@media (max-width: 450px)': {fontSize: '190%'}}];

    if(props.align) styles.push({textAlign: props.align});

    if(props.style) styles.push(props.style);

    const h1 = <h1 style={styles}>{props.title}</h1>;

    if(props.hideDivider)
      return h1;

    const separatorPosition = props.separatorPosition || "bottom";
    return <div className="scTitle">
              {separatorPosition === 'top' &&
                <Separator />
              }
              {h1}

              {separatorPosition === 'bottom' &&
                <Separator />
              }
            </div>;
});


const Divdr = Radium(Divider);

export const Separator = Radium((props) => {
    let styles = {width: '80px', height: '3px', background: '#f49600', margin: '10px auto'};

    if(props.style) 
      styles = Object.assign({}, styles, props.style);

    return <Divdr style={styles} />;
});


const DEFAULT_SLIDER_SETTINGS = {
	speed: 500,
	infinite: false,
	dots: true,
	arrows: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	swipeToSlide: true,
	swipe: true
	};

export const SCSlider = ({children, sliderRef, sliderSettings}) => {
  let settings = Object.assign({}, DEFAULT_SLIDER_SETTINGS);

  if(sliderSettings)
    settings = Object.assign(settings, sliderSettings);

  return <Slider ref={sliderRef} {...settings}>
          {children}
    </Slider>
}





// WEBPACK FOOTER //
// ./src/views/AppElements.js